import { Model } from '@vuex-orm/core';

import applyBaseModelMixin from '@/models/mixins/base-model';

export default class User extends Model {
  static entity = 'users';

  static fields() {
    return {
      email: this.string(),
      role: this.string('user'),
      settings: this.attr(/* object */),
      correctMovesCount: this.number(),
      allMovesCount: this.number(),
      correctMovesPercentage: this.number(),

      moves: this.hasMany('moves', 'userId'),
      handResults: this.hasMany('hand-results', 'userId'),
    };
  }
}

applyBaseModelMixin(User);
